import EnroulementExterieur from 'assets/img/enroulement-exterieur.png';
import EnroulementInterieur from 'assets/img/enroulement-interieur.png';
import LameFinaleSansSerrure from 'assets/img/lame-finale-sans-serrure.png';
import LameFinaleSerrure from 'assets/img/lame-finale-serrure.png';
import RideauButee from 'assets/img/rideau-butee.png';
import RideauSabot from 'assets/img/rideau-sabot.jpg';
import RideauSansButee from 'assets/img/rideau-sans-butee.png';
import RideauSansSabot from 'assets/img/rideau-sans-sabot.png';

import formInputsTypes from '../simulatorConstant';
import { BoiteManuelle, Butee, EnroulementRM, MesureHauteur, MesureLargeur } from './data';

 const BoiteRMData = {
	id: 'BoiteRMData',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Accessoires',
	name: 'BoiteRMmANUELLE',
	className: 'col-12',
	nextStepData: false,
	nextStep: false,
	options: BoiteManuelle,
	
};



const NbAgrafesRM = {
	id: 'NbAgrafesRM',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'NbAgrafesRM',
	className: 'col-6',
	label: "Nombre d'agrafes",
	nextStepData: BoiteRMData,
	nextStep: false,
};


const Enroulement = {
	id: 'RMENROULEMENT',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'Enroulement',
	className: 'col-6',
	label: 'Enroulement',
	nextStepData: NbAgrafesRM,
	nextStep: false,
	options: EnroulementRM
};

const MesureHauteurRM = {
	id: 'RMH',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'MesureHauteur',
	className: 'col-6',
	label: 'Mesure selon hauteur',
	nextStepData: Enroulement,
	nextStep: false,
	options: MesureHauteur
};

const hauteurRM = {
	id: 'HRM',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'hauteurRM',
	className: 'col-6',
	label: 'Hauteur de la lame (mm)',
	nextStepData: MesureHauteurRM,
	nextStep: false,
	validation: (value) => {
		return value > 0;
	},
};

const MesureLargeurRM = {
	id: 'RM-TML',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'MesureLargeur',
	className: 'col-6',
	label: 'Mesure selon largeur',
	nextStepData: hauteurRM,
	nextStep: false,
	options: MesureLargeur
};

const largeurRM = {
	id: 'LRM',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeurRM',
	className: 'col-6',
	label: 'Largeur de la lame (mm)',
	nextStepData: MesureLargeurRM,
	nextStep: false,
	validation: (value) => {
		return value > 0;
	},
};

export default largeurRM;
